import React from 'react';
import { Phone, Mail, MapPin, Instagram, Facebook } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { whatsappNumber, formattedWhatsappNumber, companyName, companyEmail } from '../data/mock';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-gray-900">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="text-2xl font-bold text-white">
                <span className="text-amber-400">Rent</span> With Driver
              </div>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              {t('footer.description')}
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.instagram.com/rentwithdriver.torino/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-900 hover:bg-gradient-to-br hover:from-amber-500 hover:to-amber-600 rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
              >
                <Instagram className="w-5 h-5 text-white" />
              </a>
              <a 
                href="https://www.facebook.com/rentwithdriver.torino" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-900 hover:bg-gradient-to-br hover:from-amber-500 hover:to-amber-600 rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
              >
                <Facebook className="w-5 h-5 text-white" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => document.getElementById('servizi')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-amber-400 transition-colors duration-200"
                >
                  {t('nav.services')}
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('flotta')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-amber-400 transition-colors duration-200"
                >
                  {t('nav.fleet')}
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('recensioni')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-amber-400 transition-colors duration-200"
                >
                  {t('nav.reviews')}
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('contatti')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-amber-400 transition-colors duration-200"
                >
                  {t('nav.contact')}
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold mb-4">{t('footer.contacts')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" />
                <div>
                  <a 
                    href={`https://wa.me/${whatsappNumber}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-amber-400 transition-colors duration-200"
                  >
                    {formattedWhatsappNumber}
                  </a>
                  <p className="text-gray-600 text-xs">WhatsApp 24/7</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" />
                <a 
                  href={`mailto:${companyEmail}`}
                  className="text-gray-400 hover:text-amber-400 transition-colors duration-200"
                >
                  {companyEmail}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400">
                  Torino, Piemonte<br />
                  <span className="text-gray-600 text-xs">Italia</span>
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-900">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm">
              © {currentYear} {companyName}. {t('footer.copyright')}
            </p>
            <div className="flex space-x-6 text-sm">
              <button className="text-gray-500 hover:text-amber-400 transition-colors duration-200">
                {t('footer.privacy')}
              </button>
              <button className="text-gray-500 hover:text-amber-400 transition-colors duration-200">
                {t('footer.terms')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

